const neighborhoods = [
  {
    name: "Batel",
    description: "Massagistas no Batel, bairro nobre com profissionais de alto padrão.",
    tag: "Bairro Premium",
  },
  {
    name: "Centro",
    description: "Massagistas no Centro de Curitiba, fácil acesso e ampla disponibilidade.",
    tag: "Alta Demanda",
  },
  {
    name: "Água Verde",
    description: "Profissionais especializadas no Água Verde para seu relaxamento.",
    tag: "Muito Procurado",
  },
  {
    name: "Rebouças",
    description: "Massagistas em Rebouças com atendimento discreto e profissional.",
    tag: "Popular",
  },
  {
    name: "Portão",
    description: "Encontre massagistas no Portão com ótimo custo-benefício.",
    tag: "Disponível",
  },
  {
    name: "Bigorrilho",
    description: "Profissionais no Bigorrilho / Champagnat com ambiente premium.",
    tag: "Premium",
  },
  {
    name: "Santa Felicidade",
    description: "Massagistas em Santa Felicidade para atendimento na região.",
    tag: "Disponível",
  },
  {
    name: "Pinheirinho",
    description: "Profissionais no Pinheirinho e arredores com fácil agendamento.",
    tag: "Novo",
  },
  {
    name: "São José dos Pinhais",
    description: "Massagistas em São José dos Pinhais na Região Metropolitana.",
    tag: "Região Metro",
  },
  {
    name: "Colombo",
    description: "Profissionais em Colombo – atendimento na região metropolitana.",
    tag: "Região Metro",
  },
  {
    name: "Araucária",
    description: "Massagistas em Araucária com atendimento de qualidade.",
    tag: "Região Metro",
  },
  {
    name: "Cajuru",
    description: "Encontre profissionais no Cajuru e região leste de Curitiba.",
    tag: "Disponível",
  },
];

const tagColors: Record<string, string> = {
  "Bairro Premium": "bg-amber-100 text-amber-700",
  "Alta Demanda": "bg-rose-100 text-rose-600",
  "Muito Procurado": "bg-red-100 text-red-600",
  Premium: "bg-amber-100 text-amber-700",
  Popular: "bg-stone-100 text-stone-600",
  Disponível: "bg-green-100 text-green-700",
  Novo: "bg-teal-100 text-teal-700",
  "Região Metro": "bg-blue-50 text-blue-600",
};

export default function Neighborhoods() {
  return (
    <section id="bairros" className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-rose-400 text-sm font-semibold tracking-widest uppercase mb-3 block">Cobertura Completa</span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Massagistas por Bairro em Curitiba
          </h2>
          <p className="text-stone-500 max-w-xl mx-auto text-base leading-relaxed">
            Atendimento disponível nos principais bairros de Curitiba e Região Metropolitana. Encontre a profissional mais próxima de você.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {neighborhoods.map((n, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 border border-stone-100 hover:border-rose-200 transition-all duration-300 hover:-translate-y-0.5 group"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-rose-50 rounded-xl group-hover:bg-rose-100 transition-colors">
                  <i className="ri-map-pin-line text-rose-400 text-lg"></i>
                </div>
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${tagColors[n.tag] ?? "bg-stone-100 text-stone-600"}`}>
                  {n.tag}
                </span>
              </div>
              <h3 className="text-base font-bold text-stone-800 mb-1">
                Massagistas no {n.name}
              </h3>
              <p className="text-stone-500 text-sm mb-5 leading-relaxed">{n.description}</p>
              <a
                href={`https://classivip.com/massagistas`}
                target="_blank"
                rel="nofollow noopener"
                className="inline-flex items-center gap-1.5 text-rose-400 hover:text-rose-600 text-sm font-semibold transition-colors cursor-pointer"
              >
                Ver opções
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
